import { render, staticRenderFns } from "./sender-receiver-card.vue?vue&type=template&id=5a5ec50e&scoped=true&"
import script from "./sender-receiver-card.vue?vue&type=script&lang=js&"
export * from "./sender-receiver-card.vue?vue&type=script&lang=js&"
import style0 from "./sender-receiver-card.vue?vue&type=style&index=0&id=5a5ec50e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5ec50e",
  null
  
)

export default component.exports